import React from "react";

const SwapVerticalIcon = ({ className, size = 16, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M5 2.5V13.5M2.5 11L5 13.5L7.5 11M11 13.5V2.5M8.5 5L11 2.5L13.5 5"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SwapVerticalIcon;
